import Badge from '@material-ui/core/Badge';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import {connect} from 'react-redux';
import {size} from 'lodash';
import MainFilter from './components/MainFilter';
import HidableFilters from './components/HidableFilters';

class ReportFilterBar extends React.Component {
  state = {
    open: false
  }

  handleOpen = () => this.setState({open: true});
  handleClose = () => this.setState({open: false});
  filterCount = () => {
    const {terminals} = this.props.applied;
    return size(terminals);
  }

  render() {
    const {id = 'filterBar'} = this.props;

    return (
      <div id={id} className="desktopfilters__dvrhealthcont">
        <MainFilter />
        <IconButton onClick={this.handleOpen} className="desktopfilters__dvrhealthfiltericon" id="filterIcon">
          <Badge showZero badgeContent={this.filterCount()} className="viappbar__badge-yellow">
            <Icon color="inherit" className="desktopfilters__ddicon">filter_list</Icon>
          </Badge>
        </IconButton>
        <HidableFilters open={this.state.open} onClose={this.handleClose} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {reportFilter} = state;
  return {
    ...reportFilter
  };
}

export default connect(mapStateToProps)(ReportFilterBar);
